module.exports = __webpack_public_path__ + "img/solution3.39cd8a7b.png";